// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightPreprintReport-cls1_Z5N","cls2":"CiterightPreprintReport-cls2_tsX CiterightPreprintReport-cls1_Z5N"};